export default __webpack_public_path__ + "static/media/Biology_01_08.1dbd0a93.png";